/* eslint-disable import-x/no-default-export */
export default () => ({ completed: false });
